<template>
  <div id="app">
    <header>
      <p>
        <img :src="assetsUrl" class="logo" title="Login | On-site Selfie" />
      </p>
    </header>
    <LoginForm />
    <footer class="copyright">
      ©
      <a href="//ck7.consulting/" target="_blank">CK7 Consulting Ltd.</a>
      2017-2020
    </footer>
  </div>
</template>

<script>
import LoginForm from './components/LoginForm.vue'

const { VUE_APP_ASSETS_URL } = process.env

export default {
  name: 'App',
  components: {
    LoginForm
  },
  data() {
    return {
      assetsUrl: VUE_APP_ASSETS_URL + '/images/on-site-selfie.png'
    }
  }
}
</script>

<style>
html {
  height: 100%;
}

body {
  max-width: 500px;
  height: 100%;
  margin: 0 auto;
  padding: 0;
  font: 17px 'Open Sans', 'Lucida Grande', Helvetica, Arial, sans-serif;
  color: #f3f3f3;
  background-color: #212121;
}

body > div {
  display: flex;
  flex-direction: column;
  height: 100%;
}

header {
  padding: 10px;
}

header .logo {
  width: 200px;
  margin-top: 5px;
}

footer.copyright {
  padding: 10px 20px;
  font-size: 12px;
  color: #424243;
}

footer.copyright a {
  text-decoration: none;
  color: inherit;
}
</style>
